import { useTranslation } from 'react-i18next'
import { FiDownload, FiExternalLink, FiFileText, FiPaperclip } from 'react-icons/fi'

const MessageAttachments = ({ files }) => {
  const { t } = useTranslation()

  if (!files?.length) return null

  return (
    <div className="mt-3 space-y-2 border-t border-slate-200/70 pt-3">
      <div className="flex items-center gap-1.5 text-xs font-medium text-slate-600">
        <FiPaperclip className="h-3.5 w-3.5" />
        <span>{t('support.detail.files_list', { count: files.length })}</span>
      </div>

      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {files.map((file) => {
          const isImage = file.mime_type.startsWith('image/')
          const isVideo = file.mime_type.startsWith('video/')

          if (isImage) {
            return (
              <a
                key={file.attachment_id}
                href={file.attachment_url}
                target="_blank"
                rel="noopener noreferrer"
                className="group overflow-hidden rounded-lg border border-slate-200 bg-white"
              >
                <img
                  src={file.attachment_url}
                  alt={file.original_filename}
                  loading="lazy"
                  className="max-h-64 w-full object-contain transition-transform group-hover:scale-[1.01]"
                />
                <span className="block truncate border-t border-slate-100 px-2 py-1.5 text-xs text-slate-700">
                  {file.original_filename}
                </span>
              </a>
            )
          }

          if (isVideo) {
            return (
              <div key={file.attachment_id} className="overflow-hidden rounded-lg border border-slate-200 bg-black">
                <video controls preload="metadata" className="max-h-72 w-full" aria-label={file.original_filename}>
                  <source src={file.attachment_url} type={file.mime_type} />
                </video>
                <a
                  href={file.attachment_url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center justify-between gap-2 bg-white px-2 py-1.5 text-xs text-slate-700 hover:text-[#006EAB]"
                >
                  <span className="truncate">{file.original_filename}</span>
                  <FiExternalLink className="shrink-0" />
                </a>
              </div>
            )
          }

          return (
            <div
              key={file.attachment_id}
              className="flex items-center gap-3 rounded-lg border border-slate-200 bg-white p-3"
            >
              <FiFileText className="h-7 w-7 shrink-0 text-red-500" />
              <div className="min-w-0 flex-1">
                <p className="truncate text-xs font-medium text-slate-800">{file.original_filename}</p>
                <div className="mt-1 flex gap-3 text-xs">
                  <a
                    href={file.attachment_url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-[#006EAB] hover:underline"
                  >
                    <FiExternalLink /> {t('support.detail.open_in_new_tab')}
                  </a>
                  <a
                    href={file.attachment_url}
                    download={file.original_filename}
                    className="inline-flex items-center gap-1 text-slate-600 hover:underline"
                  >
                    <FiDownload /> {t('support.detail.download_file')}
                  </a>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default MessageAttachments
